import { Box, SxProps, Theme, Typography, styled } from '@mui/material';

import { FONT_FAMILY } from '@/shared/ui/form-fields/fieldStyles';

export const generateAwbPaperSx: SxProps<Theme> = {
  width: '100%',
  maxWidth: '63.5rem',
  height: 'min(56rem, 90dvh)',
  borderRadius: '1.5rem',
  padding: '1rem',
  boxShadow: '0 1px 8px 0 rgba(0, 0, 0, 0.15)',
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
};

export const awbContentSx: SxProps<Theme> = {
  overflowY: 'auto',
  overflowX: 'hidden',
  '& .MuiFormControl-root, & .MuiTextField-root': { paddingBottom: '0 !important' },
};

export const generateAwbReviewPaperSx: SxProps<Theme> = {
  ...generateAwbPaperSx,
  height: 'auto',
  maxHeight: 'min(56rem, 90dvh)',
};

export const generateAwbResultPaperSx: SxProps<Theme> = {
  ...generateAwbPaperSx,
  maxWidth: '53.75rem',
  height: 'auto',
};

export const HeaderIcon = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'tone',
})<{ tone?: 'default' | 'success' | 'error' }>(({ theme, tone }) => ({
  width: '2.625rem',
  height: '2.625rem',
  borderRadius: '0.5rem',
  backgroundColor: {
    default: theme.palette.blue[100],
    success: theme.palette.green[100],
    error: theme.palette.red[100],
  }[tone ?? 'default'],
  color: tone === 'error' ? theme.palette.red[500] : theme.palette.blue[500],
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
}));

export const HeaderTitle = styled(Typography)(({ theme }) => ({
  fontFamily: FONT_FAMILY,
  fontSize: '1.125rem',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: '125%',
  color: theme.palette.grey[950],
}));

export const HeaderSubtitle = styled(Typography)(({ theme }) => ({
  fontFamily: FONT_FAMILY,
  fontSize: '0.75rem',
  fontStyle: 'normal',
  fontWeight: 350,
  lineHeight: '125%',
  color: theme.palette.grey[800],
}));
